import React, {useEffect} from 'react';
import FlexColumn from './shared/FlexColumn'
import {useDispatch} from 'react-redux'
import {
    fetchCustomizables
} from './redux/actions'

export default function EmptyMain({match, location, history}) {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchCustomizables(null, true));
    }, [])

    return (
        <FlexColumn alignItems="center" className="EmptyMainContainer" id="EmptyMainContainer">

        </FlexColumn>
    )

}
